import WFTrans from "./WFTrans";

export default WFTrans;